import {FC} from "react";
import {Airfield} from "../../models/Airfield";
import {Box, Container} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import AirfieldsListTable from "../../components/airfield/AirfieldsListTable";
import {PaginationResult} from "../../types/paginationResult";

interface AirfieldsPublicListProps {
    airfields: PaginationResult<Airfield>;
    recordLimit: number;
    isLoading:boolean
}

const AirfieldsList: FC<AirfieldsPublicListProps> = (props) => {
	const {airfields,recordLimit,isLoading} = props;
	const { t } = useTranslation();





	return (
		<Container maxWidth={false}>
			<Box sx={{ mt: 3 }}>
				<AirfieldsListTable
					airfields={airfields}
					recordLimit={recordLimit}
					isLoading={isLoading}
				/>
			</Box>
		</Container>
	);
}

export default AirfieldsList;
